module.exports = __webpack_public_path__ + "img/1.5df1146b.jpg";